<template>
  <v-row>
    <v-col cols="12" sm="12" md="12">
      <v-row>
        <v-col cols="12" sm="4" md="4">
          <v-select
            dense
            v-model="form.options.text"
            :items="symbolItems"
            item-text="text"
            item-value="value"
            :label="`${$t('poll.lblSymbol')}*`"
            outlined
            :menu-props="{ bottom: true, offsetY: true }"
            :disabled="isEditable"
            item-color="darkCharcoal"
            filled
            required
            :rules="[v => !!v || $t('reqSymbolRule')]"
            :id="`question-rating-${form.id}`"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-select
            dense
            v-model="levels"
            :items="levelItems"
            :label="`${$t('poll.lblLevels')}*`"
            outlined
            :menu-props="{ bottom: true, offsetY: true, maxHeight: 200 }"
            :disabled="isEditable"
            item-color="darkCharcoal"
            filled
            required
            :rules="[v => !!v || $t('reqRatingLevelRule')]"
            :id="`question-rating-lavel-${form.id}`"
          ></v-select>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="12" md="12">
      <question-text
        v-model="form.question"
        :disabled="isEditable"
        :requiredMessage="questionReq"
        :id="`question-${form.id}`"
      ></question-text>
    </v-col>
    
    <v-col cols="12" sm="12" md="12">
      <div v-if="form.options.text === 'Star'">
        <v-icon color="grey" v-for="level in levels" :key="level">
          mdi-star-outline</v-icon
        >
      </div>
      <span v-else>
        <span v-if="form.options.text === 'Number'" class="pr-5">{{ form.minLabel }}</span>
        <div class="number-style" v-for="level in levels" :key="level">
          <span style="margin-left: 7px">{{ level }}</span>
          <v-icon color="grey"> mdi-radiobox-blank</v-icon>
        </div>
        <span v-if="form.options.text === 'Number'" class="pl-5">{{ form.maxLabel }}</span>
      </span>
    </v-col>
    <v-col cols="12" sm="12" md="12">
      <v-row v-if="form.options.text === 'Number'">
        <v-col cols="12" sm="6" md="4" lg="4">
          <a-text-field
            v-model="form.minLabel"
            required
            :label="getLabelText(1)"
            outlined
            dense
            :disabled="isEditable"
          ></a-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <a-text-field
            v-model.trim="form.maxLabel"
            required
            :label="getLabelText(levels)"
            outlined
            dense
            :disabled="isEditable"
          ></a-text-field>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="12" md="12" v-if="form.isSubtitle">
      <question-text
        class="subtitle-1"
        :label="subtitleLabel"
        v-model="form.subtitle"
        :disabled="isEditable"
        :isSubtitle="form.isSubtitle"
        :requiredMessage="subtitleReq"
        :id="`question-subtitle-${form.id}`"
      ></question-text>
    </v-col>
    <v-col cols="12" sm="12" md="12">
      <question-settings v-model="form" v-if="!isEditable"></question-settings>
    </v-col>
  </v-row>
</template>

<script>
import MultipleSwitch from "./MultipleSwitch.vue";
import QuestionText from "./QuestionText.vue";
import QuestionSettings from "./QuestionSettings.vue";
import { mapGetters, mapState } from "vuex";
export default {
  components: { QuestionText, MultipleSwitch, QuestionSettings },
  name: "Rating",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    responseQuestion: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      levels1: 5,
      symbol: "Star",
      levelItems: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      mandatoryLabel: this.$t("poll.lblMandatoryResponse"),
      settings: [
        { key: "subtitle", title: "Subtitle", selected: false, value: "" },
        {
          key: "label",
          title: "Label",
          selected: false,
          value: { minLabel: "", maxLabel: "" },
        },
      ],
      question: this.value,
    };
  },
  computed: {
    ...mapState({
      surveyDetails: (state) => state.poll.surveyDetails,
    }),
    ...mapGetters({
      isSurveyExpired: "poll/isSurveyExpired",
    }),
    form: {
      get() {
        return this.question;
      },
      set(value) {
        this.question = value;
        this.$emit("input", value);
      },
    },
    levels: {
      get() {
        return this.form.options.value;
      },
      set(value) {
        this.form.options.value = value;
        this.$emit("input", this.form);
      },
    },
    questionNumber() {
      return `${this.form.number}. `;
    },
    subtitleLabel() {
      return this.$t("poll.lblSubtitle");
    },
    symbolItems() {
      return [
        { text: this.$t("poll.lblStar"), value: "Star" },
        { text: this.$t("poll.lblNumber"), value: "Number" },
      ];
    },
    questionReq() {
      return this.$t("msgQuestionRequired");
    },
    subtitleReq() {
      return this.$t("msgSubtitleRequired");
    },
    isEditable() {
      if (this.isSurveyExpired) {
        return true;
      }
      return this.responseQuestion.some(
        (item) => item.questionId === this.question.id
      );
    },
  },
  mounted() {
  },
  methods: {
    getLabelText(level) {
      return this.$t("poll.lblLabel") + ": " + level.toString();
    },
  },
};
</script>

<style scoped>
.number-style {
  display: inline-grid !important;
  font-size: 14px !important;
  margin-right: 5px;
}
</style>